import { MimeTypes } from '../utils'
import { TimeType } from './generic'
import { Language } from './organization'

export enum DocumentType {
  CSV = 'csv',
  IMAGE = 'image',
  MICROSOFT_DOCUMENT = 'microsoft_document',
  NOTE = 'note',
  NOTE_FROM_EMAIL_ANALYSIS = 'note_from_email_analysis',
  NOTE_FROM_FILE_ANALYSIS = 'note_from_file_analysis',
  PDF = 'pdf',
  TEXT = 'text',
}

type DocumentBase = {
  archivedAt?: TimeType
  createdAt: TimeType
  id: string
  language?: Language
  mimeType: MimeTypes
  type: DocumentType
  updatedAt: TimeType
}

export type DocumentNoteDTO = DocumentBase & {
  content: string
  mimeType: MimeTypes.txt
  type: DocumentType.NOTE | DocumentType.NOTE_FROM_EMAIL_ANALYSIS | DocumentType.NOTE_FROM_FILE_ANALYSIS
}

//
// File-based documents
//

export type AllowedMimeTypes =
  | MimeTypes.png
  | MimeTypes.jpeg
  // eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
  | MimeTypes.jpg
  | MimeTypes.pdf
  | MimeTypes.doc
  | MimeTypes.docx
  | MimeTypes.ppt
  | MimeTypes.pptx
  | MimeTypes.xls
  | MimeTypes.xlsx
  | MimeTypes.csv
  | MimeTypes.txt

type DocumentFile = {
  fileName: string // The original name of the file as it is stored
  size: number // Size in bytes
  title: string // Can be different from the file name OR be the same
  type: DocumentType.IMAGE | DocumentType.PDF | DocumentType.MICROSOFT_DOCUMENT | DocumentType.CSV | DocumentType.TEXT
  storageRelativePath: string // Relative path to the file in storage
}

export type DocumentImageDTO = DocumentBase &
  (DocumentFile & {
    // eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
    mimeType: MimeTypes.png | MimeTypes.jpeg | MimeTypes.jpg
    type: DocumentType.IMAGE
  })

export type DocumentPdfDTO = DocumentBase &
  (DocumentFile & {
    mimeType: MimeTypes.pdf
    type: DocumentType.PDF
  })

export type DocumentMicrosoftDocumentDTO = DocumentBase &
  (DocumentFile & {
    mimeType: MimeTypes.doc | MimeTypes.docx | MimeTypes.ppt | MimeTypes.pptx | MimeTypes.xls | MimeTypes.xlsx
    type: DocumentType.MICROSOFT_DOCUMENT
  })

export type DocumentCsvDTO = DocumentBase &
  (DocumentFile & {
    mimeType: MimeTypes.csv
    type: DocumentType.CSV
  })

export type DocumentTextDTO = DocumentBase &
  (DocumentFile & {
    mimeType: MimeTypes.txt
    type: DocumentType.TEXT
  })

export type DocumentFileDTO =
  | DocumentCsvDTO
  | DocumentImageDTO
  | DocumentMicrosoftDocumentDTO
  | DocumentPdfDTO
  | DocumentTextDTO
